<div class="storage-override-dialog">
  <h2 mat-dialog-title>{{ 'pick' | translate }} - {{ data.prdNameEn }}</h2>

  <mat-dialog-content>
    <div class="info-section">
      <div class="info-row">
        <span class="label">{{ 'storage' | translate }}:</span>
        <span class="value">{{ data.storagePath }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{ 'currentOnHand' | translate }}:</span>
        <span class="value" [class.negative]="data.currentOnHand < 0">{{ data.currentOnHand }}</span>
      </div>
    </div>

    <div class="serial-loading" *ngIf="isSerialized === null && !productError" aria-busy="true">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
    <div class="serial-load-error" role="alert" *ngIf="productError">
      <strong>{{ 'serialForm.productError' | translate }}</strong>
      <button mat-stroked-button type="button" (click)="loadProduct()">{{ 'serials.tryAgain' | translate }}</button>
    </div>

    <app-serial-form *ngIf="isSerialized === true" variant="pick"
                     [stock]="stock" [stockState]="stockState" [refused]="refused" [failed]="failed" [disabled]="isSubmitting"
                     (serialsChange)="serials = $event" (blockedChange)="blocked = $event"
                     (reload)="loadStock()" (retry)="onSubmit()"></app-serial-form>

    <form [formGroup]="form" class="override-form" *ngIf="isSerialized === false">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'quantity' | translate }}</mat-label>
        <input matInput type="number" formControlName="quantity" required min="1"
               #quantityInput (keydown.enter)="onSubmit()">
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <span class="serial-foot-note" *ngIf="isSerialized === true">{{ (serials.length === 1 ? 'serialForm.footPickOne' : 'serialForm.footPick') | translate: { count: serials.length } }}</span>
    <button mat-button (click)="onCancel()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="isSubmitting || isSerialized === null || (isSerialized ? (serials.length < 1 || blocked || stockState !== 'ready') : form.invalid)">
      <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
      <span *ngIf="!isSubmitting">{{ 'confirm' | translate }}</span>
    </button>
  </mat-dialog-actions>
</div>
